const activity = {
  activity: "Actividad", // translated
  activities: "Actividades", // translated
  dates: "fechas", // translated
  location: "Ubicación", // translated
  languages: "Idiomas", // translated
  categories: "Categorías", // translated
  ticketOption: "Opción de boleto", // translated
  numberOfRatings: "Número de calificaciones", // translated
  meetingPointInfo: "Información del punto de encuentro", // translated
  meetingPoint: "Punto de encuentro", // translated
  meetingPoints: "Puntos de encuentro", // translated
  providedBy: "Proporcionado por", // translated
  expirationDate: "Fecha de caducidad", // translated
  groupSize: "Tamaño del grupo", // translated
  features: "Características", // translated
  basedOn: "Residencia en", // translated
  reviewsFromVerCustomers: "reseñas de clientes verificados", // translated
  excellent: "excelente", // translated
  great: "excelente", // translated
  average: "promedio", // translated
  poor: "pobre", // translated
  bad: "malo", // translated
  onlyBookedCustomersTooltip: "Sólo los clientes que reservaron esta actividad pueden dejar una reseña", // translated
  noReviewsYet: "Por el momento no hay valoraciones para esta actividad.", // translated
  backToActivitiesList: "Volver a la lista de actividades", // translated
  getPrices: "obtener precios", // translated
  availabilityAndPrices: "Disponibilidad y precios", // translated
  ticketOptions: "Opciones de entradas", // translated
  ticketInfo: "Información de entradas", // translated
  selectYourTickets: "Selecciona tus entradas", // translated
  product: "Producto", // translated
  total: "Total", // translated
  slot: "Ranura", // translated
  language: "Idioma", // translated
  tickets: "Entradas", // translated
  ticketsFor: "Entradas para", // translated
  previousStep: "Paso anterior", // translated
  onlyAvailableInEnglish: "Sólo disponible en inglés", // translated
  guest: "Invitado", // translated
  leadGuest: "invitado principal", // translated
  adult: "Adulto", // translated
  child: "Niño", // translated
  pleaseSelectAdult: "Por favor seleccione al menos un adulto", // translated
  notAvailableActivity: "Este producto no está disponible", // translated
  required: "Requerido", // translated
  pickupPoint: "Punto de recogida", // translated
  pickupPoints: "Puntos de recogida", // translated
  ticketType: "Tipo de billete", // translated
  anonymous: "Anónimo", // translated
  printedVoucher: "Vale impreso aceptado", // translated
  mobileVoucher: "Vale móvil aceptado", // translated
  mixedVoucher: "Se acepta cupón móvil o impreso", // translated
  safetyMeasures: "Medidas de seguridad aplicadas", // translated
  doThisBecause: "Haz esto porque", // translated
  safetyInfo: "Información de seguridad", // translated
  reviewsHighestFirst: "Número de reseñas (las más altas primero)", // translated
  bookingFee: "Tarifa de reserva", // translated
  startDate: "Fecha de inicio", // translated
  endDate: "Fecha final", // translated
  cancellationDeadlineAndFees: "Plazo de cancelación y tarifas", // translated
  resetTickets: "Restablecer entradas", // translated
  instantConfirmation: "Confirmación instantanea", // translated
  clickResetBtn: "Haga clic en el botón Restablecer para comenzar de nuevo su selección.", // translated
};


export default activity;
